import { render, staticRenderFns } from "./clientList.vue?vue&type=template&id=8eff9f34&scoped=true&"
import script from "./clientList.vue?vue&type=script&lang=js&"
export * from "./clientList.vue?vue&type=script&lang=js&"
import style0 from "./clientList.vue?vue&type=style&index=0&id=8eff9f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eff9f34",
  null
  
)

export default component.exports